export default __webpack_public_path__ + "static/media/criticalthinking_whitecard.8a9eca9b.svg";